const riot = require('riot');

riot.tag2('page-admin-paypay_maintenances', '<div class="s-full f"> <div data-is="module-sidebar"></div> <div class="s-full f fclm p40 bg-gray_light_10"> <div class="f fm fbw mb20"> <div class="ts-h2">PayPayメンテナンス一覧</div> <div class="f fr"><a class="button primary" href="/admin/paypay_maintenances/new">PayPayメンテナンスの新規作成</a></div> </div> <div class="s-full f fclm p20 bg-white overflow-hidden"> <div class="f fm py10 px16 border-bottom border-top border-gray_light_10 bg-primary_light_50"> <div class="ts-h5">期間</div> </div> <div class="s-full overflow-scroll mb24"><a class="f fm lh14 py20 px16 hover-trigger hover-text-primary_dark_10 text-gray_dark_50 border-bottom border-gray_light_10" each="{schedule in paypayMaintenanceSchedules}" href="/admin/paypay_maintenances/{schedule.id}"><span>{dayjs(schedule.start_at).format(\'YYYY-MM-DD HH:mm\')} ~ {dayjs(schedule.end_at).format(\'YYYY-MM-DD HH:mm\')}</span></a></div> <div class="f fr mta mr20"> <div ref="pagination" data-is="atom-pagination" pagination="{pagination}"></div> </div> </div> </div> </div>', 'page-admin-paypay_maintenances,[data-is="page-admin-paypay_maintenances"]{display:block}', '', function(opts) {
    this.limit = 50;
    this.preload = async () => {
      this.fetchPaypayMaintenances();
    };

    this.on('mount', () => {
      this.refs.pagination.on('paginationchange', (offset_type) => {
        this.changePagination(offset_type);
      });
    });

    this.changePagination = async (offset_type) => {
      var indicator = spat.modal.indicator();
      var offset = this.pagination[offset_type];
      var query = {
        offset,
      };
      try {
        await this.fetchPaypayMaintenances(query);
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.fetchPaypayMaintenances = async ({offset=0} = {}) => {
      var query = {
        offset,
        limit: this.limit,
      };
      var maintenance_data = await app.api.child('paypay_maintenance_schedules').get(query);
      this.paypayMaintenanceSchedules = maintenance_data.paypay_maintenance_schedules;
      this.pagination = maintenance_data.pagination;
      this.update();
    };
});